if (!customElements.get('birthdate-select')) {

  class birthdateSelect extends HTMLElement {
    constructor() {
      super();
      
      this.day = this.querySelector('#birthdate-day');
      this.month = this.querySelector('#birthdate-month');
      this.year = this.querySelector('#birthdate-year');
      this.input = this.querySelector('#birthdate-full');
    }
    
    connectedCallback() {
      [this.day, this.month, this.year].forEach((element) => {
        element.addEventListener('change', () => {
          const value = `${this.day.value}-${this.month.value}-${this.year.value}`;
          if (/\d{2}-\d{2}-\d{4}$/.test(value)) {
            this.input.value = value.replaceAll('-', '.');
            this.input.removeAttribute('disabled');
          } else {
            this.input.setAttribute('disabled', true);
          }
        });
      });
    }
  }
  
  customElements.define('birthdate-select', birthdateSelect);
}